const _MapFuns = {
    toOption(options) {
        let _this = this;
        // include exclude同时存在时只生效include
        if (options?.include) {
            _this = _this.filter(v => options?.include?.includes(v.id));
        }
        else if (options?.exclude) {
            _this = _this.filter(v => !options?.exclude?.includes(v.id));
        }
        return _this.map(v => ({
            value: v.id,
            label: v.name
        }));
    },
    findById(id) {
        const [res] = this.filter(v => v.id === id);
        return res;
    },
    findByName(name) {
        const [res] = this.filter(v => v.name === name);
        return res;
    },
    getName(id) {
        const [res] = this.filter(v => v.id === id);
        return res?.name;
    },
    getId(name) {
        const [res] = this.filter(v => v.name === name);
        return res?.id;
    }
};
const CreateEnumMap = data => {
    const _data = [...data];
    const proto = Object.getPrototypeOf(data);
    let _obj = Object.create(proto);
    Object.assign(_obj, _MapFuns);
    Object.setPrototypeOf(_data, _obj);
    return _data;
};
export default CreateEnumMap;
